/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    shape, bool, string,
    number, object, func, arrayOf,
} from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { isEmpty } from '../../../../utils/object';
import { getCryptedOrderDetailsURL } from '../../../../utils/crypto';
import { dateMMDDYYYY } from '../../../../utils/dateString';
import EventDispatcher from '../../../../state/reducers/EventDispatcher';
import configENV from '../../../../config';
import { getSSRDeviceType } from '../../../../../../../state/ducks/App/App-Selectors';
import { getIsAuthenticatedStatus } from '../../../../../../../state/ducks/Member/ducks/Common/Common-Selectors';

const { PERSIST_KEY, ENV_NAME } = configENV;
const styles = (theme) => {
    if (ENV_NAME === 'DEV') console.log(theme);
    return {
        labelName: {
            color: theme.palette.myAccount.contentGridBorder,
            width: '50%',
            display: 'inline-block',
            '&:not(first-child)': {
                textAlign: 'center',
            },
        },
        orderNumberBlock: {
            width: '50%',
            display: 'inline-block',
            paddingTop: '12px',
            textAlign: 'center',
        },
        recentOrderWrapper: {
            position: 'relative',
            padding: '12px',
            height: 'calc(100% - 43px)',
        },
        viewAll: {
            position: 'absolute',
            bottom: '12px',
            right: '12px',
        },
    };
};

class DesktopAccountRecentOrders  extends React.Component {
    // eslint-disable-next-line camelcase
    UNSAFE_componentWillMount = async () => {
        const {
            fetchOrdersByEmail, userProfile: { isAuthenticated }, featureFlags, ssrDeviceType,
            getAuthenticatedStatus,
        } = this.props;
        if (isAuthenticated || getAuthenticatedStatus) await fetchOrdersByEmail(featureFlags, ssrDeviceType);
    };

   filterDuplicateOrder = (arr, comp) => {
       const unique = arr
           .map((e) => e[comp])
           .map((e, i, final) => final.indexOf(e) === i && i)
           .filter((e) => arr[e]).map((e) => arr[e]);
       return unique;
   }

    handleGotoURL = (url) => {
        const { history: { push } } = this.props;
        push(url);
    };

    handleOrderNumberClicked = (
        uuid,
        orderNumber,
    ) => {
        const { history } = this.props;
        if (uuid) {
            // redirect to the order detail page
            const ordersURL = getCryptedOrderDetailsURL(orderNumber, uuid);
            history.push(ordersURL);
        }
    };

    render() {
        const { orderList, classes, ROSSOrders } = this.props;
        const orderData = this.filterDuplicateOrder(orderList.length ? orderList : ROSSOrders, 'orderNumber');
        if (isEmpty(orderData)) {
            return (
                <div className="padding-top-4x bold padding-left min-height-15x">
                    You do not have any recent orders.
                </div>
            );
        }

        return (
            <>
                <div className={classes.recentOrderWrapper}>
                    <span className={classes.labelName}>Order Number</span>
                    <span className={classes.labelName}>Order Date</span>
                    <div>
                        {orderData.map((order, i) => (
                            i < 3
                                ? (
                                    <div key={order.orderNumber}>
                                        <span
                                            role="presentation"
                                            className={`link cursorPointer ${classes.orderNumberBlock}`}
                                            onClick={() => this.handleOrderNumberClicked(
                                                order.uuid,
                                                order.orderNumber,
                                            )}
                                        >
                                            {order.orderNumber}
                                        </span>
                                        <span className={`bold ${classes.orderNumberBlock}`}>  {dateMMDDYYYY(orderList.length ? order.orderPlaceddate : order.orderPlacedDate)}</span>
                                    </div>
                                )
                                : null
                        ))}
                    </div>
                    <div className={classes.viewAll}>
                        <span role="presentation" className="link cursorPointer" onClick={() => this.handleGotoURL('/account/orders')}>view all</span>
                    </div>
                </div>
            </>

        );
    }
}

DesktopAccountRecentOrders.defaultProps = {
    fetchOrdersByEmail: () => {},
    orderList: [],
    ROSSOrders: [],
    history: {},
    featureFlags: {},
};

DesktopAccountRecentOrders.propTypes = {
    classes: object.isRequired,
    fetchOrdersByEmail: func,
    history: object,
    orderList: arrayOf(
        shape({
            customerFirstName: string,
            customerLastName: string,
            intOrderNumber: string,
            items: arrayOf(
                shape({
                    addonType: string,
                    arrivalEndDate: string,
                    arrivalStartDate: string,
                    brandId: string,
                    estimatedDeliveryDate: string,
                    shipDate: string,
                    trackingNumber: string,
                }),
            ),
            modifyOrder: string,
            orderNumber: string,
            orderPlaceddate: string,
            parentOrderNumber: string,
        }),
    ),
    userProfile: shape({
        accessToken: string,
        idToken: string,
        ContactId: string,
        userType: string,
        userRole: string,
        email: string,
        aud: string,
        iat: number,
        exp: number,
        sub: string,
        firstName: string,
        lastName: string,
        loginsCount: number,
        isAuthenticated: bool,
        isGuestAccount: bool,
    }).isRequired,
    featureFlags: object,
    ssrDeviceType: string.isRequired,
    ROSSOrders: arrayOf(
        shape({
            orderNumber: string,
            status: string,
            orderPlacedDate: string,
        }),
    ),
    getAuthenticatedStatus: bool.isRequired,
};

const mapStateToProps = (state) => {
    /* istanbul ignore next */
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;
    return {
        isFetchingModal: newState.isFetchingModal,
        toggleState: newState.toggleState,
        orderList: newState.orderList,
        ssrDeviceType: getSSRDeviceType(state),
        ROSSOrders: newState.ROSSOrders,
        getAuthenticatedStatus: getIsAuthenticatedStatus(state),
    };
};

const mapDispatchToProps = (dispatch) => ({
    fetchOrdersByEmail: (featureFlags, ssrDeviceType) => dispatch(EventDispatcher.fetchOrdersByEmail(featureFlags, ssrDeviceType)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(withStyles(styles, { withTheme: true })(DesktopAccountRecentOrders)));
